import { $tag, TaggedEnumUnion, tagEnum } from '@suntex.core/types';

import { buildStaticContext } from '../utils';

import { $GradeLevel, GradeLevel } from './grade-level';

const $ = 'BonusLevel';

export const BonusLevel = {
  Bonus1: tagEnum($, 1),
  Bonus2: tagEnum($, 2),
  Bonus3: tagEnum($, 3),
  Bonus4: tagEnum($, 4),
  Bonus5: tagEnum($, 5),
  Bonus6: tagEnum($, 6),
  Bonus7: tagEnum($, 7),
  Bonus8: tagEnum($, 8),
} as const;

export type BonusLevel = TaggedEnumUnion<typeof BonusLevel>;

export const $BonusLevel = buildStaticContext({
  [$tag]: $,
  [BonusLevel.Bonus1]: {
    value: BonusLevel.Bonus1,
    slug: 'bonus-1',
    label: 'Bonus 1',
    color: $GradeLevel.describe(GradeLevel.Level1).color,
  },
  [BonusLevel.Bonus2]: {
    value: BonusLevel.Bonus2,
    slug: 'bonus-2',
    label: 'Bonus 2',
    color: $GradeLevel.describe(GradeLevel.Level2).color,
  },
  [BonusLevel.Bonus3]: {
    value: BonusLevel.Bonus3,
    slug: 'bonus-3',
    label: 'Bonus 3',
    color: $GradeLevel.describe(GradeLevel.Level3).color,
  },
  [BonusLevel.Bonus4]: {
    value: BonusLevel.Bonus4,
    slug: 'bonus-4',
    label: 'Bonus 4',
    color: $GradeLevel.describe(GradeLevel.Level4).color,
  },
  [BonusLevel.Bonus5]: {
    value: BonusLevel.Bonus5,
    slug: 'bonus-5',
    label: 'Bonus 5',
    color: $GradeLevel.describe(GradeLevel.Level5).color,
  },
  [BonusLevel.Bonus6]: {
    value: BonusLevel.Bonus6,
    slug: 'bonus-6',
    label: 'Bonus 6',
    color: $GradeLevel.describe(GradeLevel.Level6).color,
  },
  [BonusLevel.Bonus7]: {
    value: BonusLevel.Bonus7,
    slug: 'bonus-7',
    label: 'Bonus 7',
    color: $GradeLevel.describe(GradeLevel.Level7).color,
  },
  [BonusLevel.Bonus8]: {
    value: BonusLevel.Bonus8,
    slug: 'bonus-8',
    label: 'Bonus 8',
    color: $GradeLevel.describe(GradeLevel.Level8).color,
  },
} as const);
